import logger from '../utils/logger';

class LiveBackupManager {
    static BACKUP_PREFIX = 'BACKUP-';

    static isBackupName(name) {
        return typeof name === 'string' && name.startsWith(LiveBackupManager.BACKUP_PREFIX);
    }

    static generateBackupName(year, now = new Date()) {
        const safeTs = now.toISOString().replace(/[:.]/g, '-');
        return `${LiveBackupManager.BACKUP_PREFIX}${year}-${safeTs}`;
    }

    static async listBackups(draftManager) {
        const drafts = await draftManager.fetchDrafts();
        const backups = (drafts || []).filter(d => LiveBackupManager.isBackupName(d?.draft_name));
        backups.sort((a, b) => new Date(b.last_modified).getTime() - new Date(a.last_modified).getTime());
        return backups;
    }

    static async createBackup(assetManager, year) {
        const name = LiveBackupManager.generateBackupName(year);
        logger.debug('[LiveBackupManager] Creating live backup:', { name, year });
        await assetManager.saveDraft(name, year, false);
        return name;
    }

    static async pruneBackups(assetManager, draftManager, keep = 20) {
        try {
            const backups = await LiveBackupManager.listBackups(draftManager);
            if (backups.length <= keep) return { kept: backups.length, deleted: 0 };
            const toDelete = backups.slice(keep);
            for (const b of toDelete) {
                try {
                    logger.debug('[LiveBackupManager] Deleting old backup:', b.draft_name);
                    await assetManager.deleteDraft(b.draft_name);
                } catch (_) { }
            }
            return { kept: keep, deleted: toDelete.length };
        } catch (e) {
            logger.warn('[LiveBackupManager] pruneBackups failed (non-fatal):', e);
            return { kept: 0, deleted: 0 };
        }
    }

    static async backupCurrentLive(assetManager, draftManager, year, keep = 20) {
        const name = await LiveBackupManager.createBackup(assetManager, year);
        await LiveBackupManager.pruneBackups(assetManager, draftManager, keep);
        return name;
    }

    static async openBackupAsDraft(name, draftManager, onModeChange) {
        if (!name) return;
        try {
            if (draftManager) {
                draftManager.setDraftMode(name);
            }
            if (typeof onModeChange === 'function') {
                onModeChange(false, name);
            }
        } catch (e) {
            // no-op
        }
    }
}

export default LiveBackupManager;


